import { useRef } from "react";
import { APIProvider, Map as GoogleMap, AdvancedMarker } from "@vis.gl/react-google-maps";
import { Paper } from "@mui/material";
import { EventPin } from "@root/components/common/EventPin";

interface EventLocationMapProps {
    latitude: number;
    longitude: number;
    pinHue?: string;
    iconUrl?: string;
    height?: number | string;
}

export const EventLocationMap = ({
    latitude,
    longitude,
    pinHue = "#FF0000",
    iconUrl,
    height = 200,
}: EventLocationMapProps) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const center = { lat: latitude, lng: longitude };

    return (
        <Paper
            ref={containerRef}
            elevation={0}
            sx={{
                width: "100%",
                height,
                borderRadius: "12px",
                overflow: "hidden",
                position: "relative",
                border: "1px solid #E0E0E0",
            }}
        >
            <APIProvider apiKey={import.meta.env.PUBLIC_ENV__GOOGLE_MAPS_API_KEY}>
                <GoogleMap
                    mapId={import.meta.env.PUBLIC_ENV__GOOGLE_MAPS_LANDING_PAGE_MAP_ID}
                    defaultCenter={center}
                    defaultZoom={15}
                    gestureHandling="greedy"
                    disableDefaultUI
                    zoomControl={true}
                    style={{ width: "100%", height: "100%" }}
                >
                    <AdvancedMarker position={center}>
                        <EventPin
                            iconUrl={iconUrl}
                            pinHue={pinHue}
                            size="large"
                            useMuiBox={false}
                        />
                    </AdvancedMarker>
                </GoogleMap>
            </APIProvider>
        </Paper>
    );
};
